// src/index.js
/**
=========================================================
* Material Dashboard 2 React - Authentication Example
=========================================================
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error(
    "The root element was not found. Ensure that your public/index.html contains <div id='root'></div>."
  );
}
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
